<template>
    <div :class="{'cursor-wait' : isLoading}" class="inline">
        <span @click="openModal" class="text-base text-center text-accent-primary underline hover:cursor-pointer">*</span>
        <base-modal :is-form-visible="isOpen" @close="closeModal">
            <template #header> <span class="text-base"> {{ company.company_name }} Descriptions <a v-if="company.website_url" target="_blank" class="text-accent-primary underline" :href="company.website_url">{{ company.website_url }}</a></span></template>
            <template #body>
                <div class="grid grid-cols-2 gap-4 w-full p-2 text-xs h-full overflow-auto">
                    <div v-if="loadingDescriptions" class="flex justify-center w-full p-2">
                    <svg aria-hidden="true" class="mx-1 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600"
                      viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="white"/>
                      <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="#2E9CCA"/>
                    </svg>
                    <span class="sr-only">Loading...</span>
                  </div>
                    <div class="flex flex-col space-y-3 pr-1" v-else>
                        <div>
                            <h2 class="underline">Current Description:</h2>
                            <div class="flex items-center space-x-2">
                                <div class="w-5/6">
                                    {{ company.description ? company.description : "None" }}
                                </div>
                                <div @click="transferDescription(company.description)" class="w-1/6 underline hover:cursor-pointer">
                                    >>
                                </div>
                            </div>
                        </div>
                        <div v-if="ziDescription">
                            <h2 class="underline">Zoom Info Description:</h2>
                            <div class="flex items-center space-x-2">
                                <div class="w-5/6">
                                    {{ ziDescription }}
                                </div>
                                <div @click="transferDescription(ziDescription)" class="w-1/6 underline hover:cursor-pointer">
                                    >>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col space-y-2" v-if="chatGptDescriptions.length > 0">
                            <h2 class="underline">Chat GPT Descriptions:</h2>
                            <div v-for="(description, idx) in chatGptDescriptions" :key="idx" class="flex items-center space-x-2">
                                <div :class="{'border-b border-dotted border-b-dark-primary' : chatGptDescriptions.length > 1 && idx < chatGptDescriptions.length - 1}"  class="w-5/6">
                                  {{ formatDateTwoDigitYear(description.created_at) }}:  {{ description.description }}
                                </div>
                                <div @click="transferDescription(description.description)" class="w-1/6 underline hover:cursor-pointer">
                                    >>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col pl-1">
                        <!-- <h2 class="underline">Current Description:</h2> -->
                        <textarea id="descriptionTextArea" class="border border-dark-primary rounded-md p-2" name="" cols="30" rows="10" v-model="companyDescription"></textarea>
                        <div class="p-2 text-center">

                    <div v-if="isLoading" class="flex justify-center w-full p-2">
                    <svg aria-hidden="true" class="mx-1 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600"
                      viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="white"/>
                      <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="#2E9CCA"/>
                    </svg>
                    <span class="sr-only">Loading...</span>
                  </div>
                            <div class="rounded-md px-1 py-1 bg-accent-primary text-white border border-accent-primary  hover:shadow-md active:text-white active:bg-accent-secondary focus:text-white focus:bg-accent-secondary text-xs cursor-pointer sm:text-xs sm:h-fit" v-else @click.stop.prevent="saveDescription">Save</div>
                        </div>
                    </div>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
export default {
    name: 'company-description-aggregator'
}
</script>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { getDescriptions, updateCompany } from '@/services/Company';
import { useToast } from 'vue-toast-notification';
import { formatDateTwoDigitYear } from '@/composables/formatDate';

const store = useStore()
const $toast = useToast()
const emit = defineEmits(['refetch-companies'])

const props = defineProps({
    company: Object
})

const isOpen = ref(false)
const loadingDescriptions = ref(false)
const isLoading = ref(false)

const ziDescription = ref('')

const chatGptDescriptions = ref([])

function openModal() {
    isOpen.value = true
    loadDescriptions()

}

function closeModal() {
    isOpen.value = false
}

const companyDescription = ref(props.company ? props.company.description : null)

async function loadDescriptions(){
    loadingDescriptions.value = true
    const token = store.state.auth.token 
    const result = await getDescriptions(token, props.company.id)
    ziDescription.value = result.zoom_info
    chatGptDescriptions.value = result.chat_gpt
    loadingDescriptions.value = false
    // addFocus() 
 
}

function transferDescription(description) {
    if(companyDescription.value) {
        companyDescription.value += ` ${description}`
    } else {
        companyDescription.value = description
    }
}

async function saveDescription(){
    isLoading.value = true
    const token = store.state.auth.token 
    const data = JSON.stringify({
        description: companyDescription.value
    })
    const result = await updateCompany(props.company.id, data, token)
    if(result.status == 200){
        $toast.success(`Successfully updated ${props.company.company_name} description!`)
    } else {
        $toast.error(`Could not update ${props.company.company_name} description`)
    }
    isLoading.value = false
    emit('refetch-companies')
}

// function addFocus() {
//     document.activeElement.blur()
//     const edit = document.getElementById("descriptionTextArea")
//     edit.focus()
// }


</script>